import { useState} from "react";
import { Outlet } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { AppSidebar, AppTopbar, ExceptionMessage } from "../components";

export interface AppLayoutProps extends React.PropsWithChildren {
  includeSidebar?: boolean;
  includeTopbar?: boolean;
  footerless?: boolean;
}

export function AppLayout({
  includeSidebar = true,
  includeTopbar = true,
  footerless = false,
  children
}: Readonly<AppLayoutProps>) {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  const onMenuToggle = () => {
    setIsMenuExpanded(!isMenuExpanded);
  };

  const handleMobileSidebarNavigate = () => {
    if(window.innerWidth < 992){
      setIsMenuExpanded(false)
    }
  }

  return (
    <div id="main-wrapper" className="position-fixed d-flex flex-column w-100 h-100">
      {includeTopbar &&
        <div id="main-topbar" className="position-relative flex-shrink-1">
          <AppTopbar showToggle={true} onToggle={onMenuToggle}></AppTopbar>
        </div>
        }
      <div className="position-relative flex-grow-1">
        <div className="position-absolute d-flex flex-row w-100 h-100">
          {includeSidebar && (
            <nav id="main-menu" className={`h-100 mh-100 ${isMenuExpanded ? "expanded" : ""}`} style={{"width": isMenuExpanded ? '20rem' : ''}}>
              <AppSidebar showToggle={true} onToggle={onMenuToggle} onNavigate={handleMobileSidebarNavigate}/>
            </nav>
          )}
          <div id="main-menu-overlay" className={`d-lg-none ${isMenuExpanded ? "show" : ""}`} onClick={onMenuToggle}></div>
          <main id="main-content" role="main" className="flex-grow-1 h-100 mh-100 w-100 overflow-auto">
            <AnimatePresence>
              <div key="exception" className="d-flex justify-content-center">
                <ExceptionMessage />
              </div>
              <div key="page" className="h-100">
                {children ?? <Outlet />}
              </div>
            </AnimatePresence>
          </main>
        </div>
      </div>
    </div>
  );
}

export default AppLayout;
